import { useState, useEffect } from "react";

import BoardHeader from "./BoardHeader";
import QuickTable from "./QuickTable";
import QuickForm from "components/Meta/QuickForm";
import QuickCards from "./QuickCards";
import CalendarFilter from "components/Tools/CalendarFilter";
import mainStore from "store/mainStore";
import { classNames } from "tools/ui";
import { getStorage } from "store/local";

const VIEWS = {
  list: QuickTable,
  form: QuickForm,
  cards: QuickCards,
};

function Board(props) {
  const session = getStorage("ctxSession");

  const {
    ctxView,
    returnFilter,
    currentView,
    calendar,
    handleCalendar,
    Toolbar,
    reload,
    onChangeDate,
  } = props;

  const startView = ctxView?.defaultView;

  const [viewType, setViewType] = useState(startView || "list");
  const [action, setAction] = useState(null);
  const [domain, setDomain] = useState(ctxView?.domain || null);

  useEffect(() => {
    if (onChangeDate && ctxView.domain) {
      setDomain(ctxView.domain);
    }
  }, [onChangeDate, ctxView.domain]);

  async function onChangeView(event, action, record) {
    setAction(action);
    let _viewType = viewType;

    const { newRecord, setRecord, reset } = mainStore.getState();

    if (action !== "return") {
      if (!record) {
        await newRecord(ctxView);
      } else {
        await setRecord(record.id, ctxView.model, ctxView);
      }
    } else {
      reset(true);
    }

    if (["edit", "add"].includes(action)) {
      _viewType = "form";
    } else if (["cards"].includes(action)) {
      _viewType = "cards";
    } else {
      _viewType = "list";
    }
    setViewType(_viewType);

    if (currentView) {
      currentView(_viewType);
    }
  }

  function onClickAction(event, action) {
    setAction(action);
  }

  async function handleFilter(filter) {
    setDomain(filter);
    if (returnFilter) {
      returnFilter(filter);
    }
  }

  const View = VIEWS[viewType] || QuickTable;

  const style = props.style || "w-full";

  return (
    <div id="board" className={classNames("px-3 py-3 lg:px-4", style)}>
      {viewType === "list" && calendar && (
        <CalendarFilter action={handleCalendar} styleContent="pl-4" />
      )}

      {viewType !== "form" && (
        <BoardHeader
          ctxView={ctxView}
          viewType={viewType}
          onChangeView={onChangeView}
          onChangeDate={onChangeDate}
          onClickAction={onClickAction}
          handleFilter={handleFilter}
          Toolbar={Toolbar}
        />
      )}

      <View
        key={viewType}
        ctxView={ctxView}
        onChangeView={onChangeView}
        session={session}
        action={action}
        level="main"
        reload={reload}
        returnFilter={returnFilter}
        domain={domain}
      />
    </div>
  );
}

export default Board;
